module.exports = __webpack_public_path__ + "img/3.2acf5bd8.svg";